module.exports = __webpack_public_path__ + "img/can-vpn-hide-ip-address.d80e8927.png";